import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M20.048 13V5a1 1 0 0 0-1-1h-2v10h2a1 1 0 0 0 1-1m-5 1V4H8.402a2 2 0 0 0-1.857 1.257l-2.4 6A2 2 0 0 0 6.002 14h3.046c-1 3 0 5 2 5a2 2 0 0 0 2-2v-1a2 2 0 0 1 2-2"
    }
  )
);
var SvgThumbsDownFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ThumbsDownFilled_default = SvgThumbsDownFilled;

export { ThumbsDownFilled_default as default };
